var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"container"},[_c('p',[_vm._v("404 | "+_vm._s(_vm.$t('default.page_not_found')))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }